const actions = {
  setUser: (context, value) => {
    context.commit('SET_CURRENT_USER', value);
  },
  setCity: (context, value) => {
    context.commit('SET_CURRENT_CITY', value);
  },
  setCenterMap: (context, value) => {
    context.commit('SET_CENTER_MAP', value);
  },
  setMerchant: (context, value) => {
    context.commit('SET_CURRENT_MERCHANT', value);
  },
  setCurrentPlaceID: (context, value) => {
    context.commit('SET_CURRENT_PLACE_ID', value);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js